import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, path = '', ogType = 'website', ogImage, schema }) {
  const siteTitle = "Moon Yoga Fredericia";
  const fullTitle = title ? `${title}` : siteTitle;
  const liveDomain = "https://moonyoga-fredericia.dk";
  const canonicalUrl = `${liveDomain}${path}`;
  
  // Default OG Image (using a high-quality hero image from the site)
  const defaultOgImage = "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0038-enhanced-nr-red2.jpg";
  const finalOgImage = ogImage || defaultOgImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Language Lock */}
      <html lang="da" />

      {/* Robots - Allow indexing on live */}
      <meta name="robots" content="index, follow" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:image" content={finalOgImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={finalOgImage} />

      {/* Structured Data / Schema Markup */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
